import script from "./MonthCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./MonthCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./MonthCalendar.vue?vue&type=style&index=0&id=3e3df25f&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e3df25f"]])

export default __exports__